<template>
  <v-card flat>
    <v-card-text>
      <div class="container-fluid">
        <h4 class="text-center pt-5">ERP Ayarları</h4>
        <v-divider></v-divider>
        <div class="row">
          <div class="col-md-4">
            <label for="">Server</label>
            <v-text-field v-model="erpSettingsObject.server" filled dense solo></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">DB Adı</label>
            <v-text-field v-model="erpSettingsObject.dbName" filled dense solo></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">DB Kullanıcı Adı</label>
            <v-text-field v-model="erpSettingsObject.dbUserName" filled dense solo></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">DB Parola</label>
            <v-text-field v-model="erpSettingsObject.dbPassword" filled dense solo type="password"></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Şirket Adı</label>
            <v-text-field v-model="erpSettingsObject.netsisCompanyName" filled dense solo></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Şube Kodu</label>
            <v-text-field
                v-model="erpSettingsObject.netsisBranchCode"
                filled
                dense
                solo
            >
            </v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Depo Kodu</label>
            <v-text-field v-model="erpSettingsObject.netsisWarehouseCode" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Kullanıcı Adı</label>
            <v-text-field ref="firstValidationError"
                          v-model="erpSettingsObject.netsisUserName" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Kullanıcı Şifre</label>
            <v-text-field v-model="erpSettingsObject.netsisUserPassword" solo filled dense
                          type="password"></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">NetOpenX Rest Url Adresi</label>
            <v-text-field v-model="erpSettingsObject.netOpenXRestUrl" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Cari Seri</label>
            <v-text-field v-model="erpSettingsObject.netsisCurrentSerie" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Sipariş Seri</label>
            <v-text-field v-model="erpSettingsObject.netsisOrderSerie" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Dolar Kodu</label>
            <v-text-field v-model="erpSettingsObject.netsisUsdCode" solo filled dense min="1"
                          type="number"></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Euro Kodu</label>
            <v-text-field v-model="erpSettingsObject.netsisEuroCode" solo filled dense min="1"
                          type="number"></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Sterlin Kodu</label>
            <v-text-field v-model="erpSettingsObject.netsisGbpCode" solo filled dense min="1"
                          type="number"></v-text-field>
          </div>
        </div>
        <h4 class="text-center pt-5">E-Logo Ayarları</h4>
        <v-divider></v-divider>
        <div class="row">
          <div class="col-md-6">
            <label for="">E-Logo Kullanıcı Adı</label>
            <v-text-field
                v-model="erpSettingsObject.eLogoUserName"
                solo
                filled
                dense
                :error-messages="
                  validationMessages($v.erpSettingsObject.eLogoUserName, 'E-Logo Kullanıcı')
                "
            >
            </v-text-field>
          </div>
          <div class="col-md-6">
            <label for="">E-Logo Şifre</label>
            <v-text-field v-model="erpSettingsObject.eLogoPassword" solo filled dense type="password" :error-messages="
                  validationMessages($v.erpSettingsObject.eLogoPassword, 'E-logo Şifre')
                "></v-text-field>
          </div>
        </div>
        <h4 class="text-center pt-5">Uygulama İçi Ayarlar</h4>
        <v-divider></v-divider>
        <div class="row">
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.netsisCurrencySale" dense inset label="ERP Dövizli Satış"></v-switch>
            <v-select
                v-model="erpSettingsObject.netsisCurrencySaleType"
                :items="['DOV_SATIS', 'EFF_SATIS', 'DOV_ALIS', 'EFF_ALIS']"
                v-if="erpSettingsObject.netsisCurrencySale"
                solo
                filled
                dense
            >
            </v-select>
          </div>
          <div class="col-md-4">
            <v-switch
                v-model="erpSettingsObject.stockListShowBalance"
                dense
                inset
                label="Stok Listesinde Bakiye Gösterimi"
            ></v-switch>

            <v-select
                v-model="erpSettingsObject.hideBalanceType"
                :items="[{text:'Var/Yok Gösterim',value:1}, {text:'Rakamsal Gösterim',value:2}]"
                :item-text="item => item.text"
                :item-value="item => item.value"
                v-if="!erpSettingsObject.stockListShowBalance"
                solo
                filled
                dense
            >
            </v-select>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.cartShowBalance" dense inset label="Sepet Bakiye Gösterimi"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.orderApprove" dense inset label="Sipariş Onay"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.conditionOperation" dense inset label="Koşul Uygulaması"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch
                v-model="erpSettingsObject.campaignOperation"
                dense
                inset
                label="Kampanya Uygulaması"
            ></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.salesPersonOffersAdminApproveToCustomer" dense inset
                      label="Plasiyer Teklif Onay"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.paymentSaveErp" dense inset label="Ödeme Onay"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.paymentMethodDiscount" dense inset
                      label="Ödeme Tipi İskontosu"></v-switch>
          </div>
          <!--
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.hideBalanceType" dense inset label="Stok Bakiye Sepet Kontrolü"></v-switch>
          </div>-->
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.minimumStockConstraint" dense inset
                      label="Minimum Stok Kısıtı"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.maximumStockConstraint" dense inset
                      label="Maksimum Stok Kısıtı"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.stockBalanceAddCart" dense inset
                      label="Stok Eksi Bakiye Sepete Ekleme"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.stockBalanceUnderAddCart" dense inset
                      label="Stok Bakiye Üzerinde Sepete Ekleme"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.zeroStockBalanceGet" dense inset
                      label="Sıfır Stok Bakiyeli Ürünleri Getir"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.minimumStockMultipleConstraint" dense inset
                      label="Minimum Stok Miktarı ve Katları Sepete Eklenebilir"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.multipleCompanyCurrentBalance" dense inset
                      label="Farklı Şirketlerdeki Cari Bakiyeleri Göster"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.multipleCompanyStockBalance" dense inset
                      label="Farklı Şirketlerdeki Stok Bakiyeleri Göster"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.userBranch" dense inset label="Şube Yapısı"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.userWarehouse" dense inset label="Depo Yapısı"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.userSafe" dense inset label="Kullanıcı Bazında Kasa"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.cartCurrencyShow" dense inset
                      label="Dövizli Sepet Kullanımı"></v-switch>
          </div>
          <!--          <div class="col-md-4">-->
          <!--            <v-switch dense inset label="Projeleri Gör"></v-switch>-->
          <!--          </div>-->
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.onlyCurrency" dense inset label="Sadece Döviz Kullanımı"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.allBranchShow" dense inset label="Tüm Şubeleri Göster"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.basketNotUpdate" dense inset
                      label="Sepet görüntülemede güncelleme yapma"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.localWarehouse" dense inset label="Lokal Depo Uygulaması"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.cartProjectProcess" solo inset label="Sepette Proje Süreci"></v-switch>
          </div>
          <div class="col-md-4" v-if="erpSettingsObject.cartProjectProcess">
            <v-switch v-model="erpSettingsObject.projectPhaseCustomerOrderEdit" solo inset
                      label="Proje Aşamasında Müşteri Sipariş Düzenleme"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.salesPersonOrderApprove" solo inset
                      label="Plasiyer Sipariş Onay"></v-switch>
          </div>
          <div class="col-md-4">
            <v-switch v-model="erpSettingsObject.currencyCurrentProcess" solo inset
                      label="Müşteri Cari Seçimi"></v-switch>
          </div>
          <hr>
          <div v-if="erpSettingsObject.cartProjectProcess" class="col-md-4">
            <label for="">Proje Kodu</label>
            <v-text-field v-model="erpSettingsObject.projectCode" filled dense solo></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">Lokal Depo Kodu</label>
            <v-text-field v-model="erpSettingsObject.localWarehouseCode" filled dense solo></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">ERP Satış Fiyatı</label>
            <v-select
                v-model="erpSettings.netsisSalePrice"
                :items="[
                'SATIS_FIAT1',
                'SATIS_FIAT2',
                'SATIS_FIAT3',
                'SATIS_FIAT4',
              ]"
                filled
                dense
                solo
            >
            </v-select>
          </div>
          <div class="col-md-4">
            <label for="">Stok Arama</label>
            <v-select
                v-model="erpSettingsObject.stockSearch"
                :items="[{ value: true, text: 'İçeren' },{ value: false, text: 'Başlayan' }]"
                :item-text="item => item.text"
                :item-value="item => item.value"
                filled
                dense
                solo>
            </v-select>
          </div>
          <div class="col-md-4">
            <label for="">Cari Arama</label>

            <v-select
                v-model="erpSettingsObject.currentSearch"
                :items="[{ value: true, text: 'İçeren' },{ value: false, text: 'Başlayan' }]"
                :item-text="item => item.text"
                :item-value="item => item.value"
                filled
                dense
                solo>
            </v-select>
          </div>
          <div class="col-md-4">
            <label for="">Stok KDV Durumu</label>
            <v-select
                v-model="erpSettingsObject.stockVatStatus"
                :items="[{value: true, text: 'KDV Dahil'},{value: false, text: 'KDV Hariç'}]"
                :item-text="item => item.text"
                :item-value="item => item.value"
                filled
                dense
                solo
            >
            </v-select>
          </div>
          <div class="col-md-4">
            <label for="">Stok Liste Sıralama</label>
            <v-select
                v-model="erpSettingsObject.stockListOrderBy"
                :items="[{value:1,text :'Stok Kodu'},{value:2,text :'Bakiye (Azalan)'},{value:3,text :'Stok Adı'}]"
                :item-text="item => item.text"
                :item-value="item => item.value"
                filled
                dense
                solo
            >
            </v-select>
          </div>
          <div class="col-md-4">
            <label for="">Stok Bakiye Limiti</label>
            <v-text-field v-model="erpSettingsObject.stockBalanceLimit" filled dense solo></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">Özel Kod 1</label>
            <v-text-field v-model="erpSettingsObject.specialCode1" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">Özel Kod 2</label>
            <v-text-field v-model="erpSettingsObject.specialCode2" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">Nakit Kasa Kodu</label>
            <v-text-field v-model="erpSettingsObject.cashSafeCode" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="">Nakit Kasa Cari Hareket Açıklaması</label>
            <v-text-field v-model="erpSettingsObject.cashCurrentActionDescription" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="" class="fs-6">Kredi Kartı Kasa Cari Hareket Açıklaması</label>
            <v-text-field v-model="erpSettingsObject.CreditCartCurrentActionDescription" solo filled
                          dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="" class="fs-6">Kredi Kartı Kasa Kodu</label>
            <v-text-field v-model="erpSettingsObject.creditCartSafeCode" solo filled dense></v-text-field>
          </div>
          <div class="col-md-4">
            <label for="" class="fs-6">Stok Bakiye Tipi</label>
            <v-select
                v-model="erpSettingsObject.stockBalanceType"
                :items="[{value: 1, text: 'Şube'},{value: 2, text: 'Depo'},{value: 3, text: 'Hepsi'}]"
                item-value="value"
                item-text="text"
                solo
                filled
                dense
            >
            </v-select>
          </div>
          <div class="col-md-4">
            <label for="" class="fs-6">Minimum Satış Fiyatı Kontrolü</label>
            <v-select
                v-model="erpSettingsObject.minimumSalePriceControl"
                :items="[{value: true, text: 'Yapılsın'},{value: false, text: 'Yapılmasın'}]"
                item-value="value"
                item-text="text"
                solo
                filled
                dense
            >
            </v-select>
          </div>
          <div class="col-md-4">
            <label v-if="erpSettingsObject.minimumSalePriceControl"
                   for="" class="fs-6">Minimum Satış Fiyatı Alanı</label>
            <v-select
                v-model="erpSettingsObject.minimumSalePriceField"
                :items="[
                    {value: 1, text: 'KULL1N'},
                    {value: 2, text: 'KULL2N'},
                    {value: 3, text: 'KULL3N'},
                    {value: 4, text: 'KULL4N'},
                    {value: 5, text: 'KULL5N'},
                    {value: 6, text: 'KULL6N'},
                    {value: 7, text: 'KULL7N'},
                    {value: 8, text: 'KULL8N'},
                    ]"
                item-value="value"
                item-text="text"
                v-if="erpSettingsObject.minimumSalePriceControl"
                solo
                filled
                dense
            >
            </v-select>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12 text-end">
            <v-btn color="success darken-2" depressed @click="saveErpSettings()"
            >
              <v-icon left>mdi-content-save</v-icon>
              Kaydet
            </v-btn
            >
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>


import {mapState, mapActions} from 'vuex';
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import {validationMessages} from "@/validationMessages";

export default {
  mixins: [validationMixin],

  validations() {
    return {
      erpSettingsObject: {
        eLogoUserName: {required},
        eLogoPassword: {required},
      },
    };
  },
  props: {
    settingsProp: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth", ["user"])
  },
  mounted() {

  },
  data() {
    return {
      erpSettingsObject: {},

    }
  },
  methods: {
    validationMessages,
    ...mapActions("settings", ["erpSettingUpdate"]),
    async saveErpSettings() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.erpSettingUpdate({
          params: {
            userId: this.user.UserId
          },
          body: {
            "NetsisCompanyName": this.erpSettingsObject.netsisCompanyName,
            "NetsisBranchCode": this.erpSettingsObject.netsisBranchCode,
            "OrderApprove": this.erpSettingsObject.orderApprove,
            "SalesPersonOffersAdminApproveToCustomer": this.erpSettingsObject.salesPersonOffersAdminApproveToCustomer,
            "NetsisUserName": this.erpSettingsObject.netsisUserName,
            "NetsisUserPassword": this.erpSettingsObject.netsisUserPassword,
            "NetsisOrderSerie": this.erpSettingsObject.netsisOrderSerie,
            "NetsisCurrentSerie": this.erpSettingsObject.netsisCurrentSerie,
            "NetOpenXRestUrl": this.erpSettingsObject.netOpenXRestUrl,
            "NetOpenXRestRestart": false,
            "NetsisWarehouseCode": this.erpSettingsObject.netsisWarehouseCode,
            "NetsisCurrencySale": this.erpSettingsObject.netsisCurrencySale,
            "NetsisCurrencySaleType": this.erpSettingsObject.netsisCurrencySaleType,
            "eLogoUserName": this.erpSettingsObject.eLogoUserName,
            "eLogoPassword": this.erpSettingsObject.eLogoPassword,
            "StockListShowBalance": this.erpSettingsObject.stockListShowBalance,
            "HideBalanceType": this.erpSettingsObject.hideBalanceType,// Stok Bakiye Sepet Kontrolü
            "StockBalanceLimit": this.erpSettingsObject.stockBalanceLimit,
            "CartShowBalance": this.erpSettingsObject.cartShowBalance, // Stok Listesinde BAkiye Gösterilsin mi
            "ConditionOperation": this.erpSettingsObject.conditionOperation,
            "CampaignOperation": this.erpSettingsObject.campaignOperation,
            "PaymentMethodDiscount": this.erpSettingsObject.paymentMethodDiscount,
            "NetsisSalePrice": this.erpSettingsObject.netsisSalePrice,
            "SpecialCode1": this.erpSettingsObject.specialCode1,
            "SpecialCode2": this.erpSettingsObject.specialCode2,
            "PaymentSaveErp": this.erpSettingsObject.paymentSaveErp,
            "CurrentSearch": this.erpSettingsObject.currentSearch,// Cari Araması Nasıl Yapılsın
            "StockSearch": this.erpSettingsObject.stockSearch,// Stok Araması Nasıl Yapılsın
            "StockBalanceAddCart": this.erpSettingsObject.stockBalanceAddCart,//
            "StockBalanceUnderAddCart": this.erpSettingsObject.stockBalanceUnderAddCart,//
            "MinimumStockConstraint": this.erpSettingsObject.minimumStockConstraint,
            "MaximumStockConstraint": this.erpSettingsObject.maximumStockConstraint,
            "StockVatStatus": this.erpSettingsObject.stockVatStatus,//Stok KDV Durumu
            "StockListOrderBy": this.erpSettingsObject.stockListOrderBy,
            "NetsisUsdCode": this.erpSettingsObject.netsisUsdCode,
            "NetsisEuroCode": this.erpSettingsObject.netsisEuroCode,
            "NetsisGbpCode": this.erpSettingsObject.netsisGbpCode,
            "ZeroStockBalanceGet": this.erpSettingsObject.zeroStockBalanceGet,
            "MinimumStockMultipleConstraint": this.erpSettingsObject.minimumStockMultipleConstraint,
            "CashSafeCode": this.erpSettingsObject.cashSafeCode,
            "CashCurrentActionDescription": this.erpSettingsObject.cashCurrentActionDescription,
            "CreditCardSafeCode": this.erpSettingsObject.creditCardSafeCode,
            "CreditCardCurrentActionDescription": this.erpSettingsObject.creditCardCurrentActionDescription,
            "MultipleCompanyCurrentBalance": this.erpSettingsObject.multipleCompanyCurrentBalance,
            "MultipleCompanyStockBalance": this.erpSettingsObject.multipleCompanyStockBalance,
            "UserBranch": this.erpSettingsObject.userBranch,
            "UserWarehouse": this.erpSettingsObject.userWarehouse,
            "UserSafe": this.erpSettingsObject.userSafe,
            "CartCurrencyShow": this.erpSettingsObject.cartCurrencyShow,
            "StockBalanceType": this.erpSettingsObject.stockBalanceType,
            "MinimumSalePriceControl": this.erpSettingsObject.minimumSalePriceControl,
            "MinimumSalePriceField": this.erpSettingsObject.minimumSalePriceField,
            "LocalWarehouse": this.erpSettingsObject.localWarehouse,//bool
            "LocalWarehouseCode": this.erpSettingsObject.localWarehouseCode,//number
            "AllBranchShow": this.erpSettingsObject.allBranchShow,//bool
            "BasketNotUpdate": this.erpSettingsObject.basketNotUpdate,//bool
            "OnlyCurrency": this.erpSettingsObject.onlyCurrency,//bool
            "Server": this.erpSettingsObject.server,//string
            "DbName": this.erpSettingsObject.dbName,//string
            "DbUserName": this.erpSettingsObject.dbUserName,//string
            "DbPassword": this.erpSettingsObject.dbPassword,//string
            "CartProjectProcess": this.erpSettingsObject.cartProjectProcess,
            "ProjectCode": this.erpSettingsObject.projectCode,
            "ProjectPhaseCustomerOrderEdit": this.erpSettingsObject.projectPhaseCustomerOrderEdit,
            "SalesPersonOrderApprove" : this.erpSettingsObject.salesPersonOrderApprove,
            "CurrencyCurrentProcess" : this.erpSettingsObject.currencyCurrentProcess,
          }
        })
      } else {
        // Find the first validation error element
        const firstValidationErrorElement = this.$refs.firstValidationError;
        if (firstValidationErrorElement) {
          // Scroll to the first validation error element
          firstValidationErrorElement.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
    }
  },
  watch: {
    "settingsProp": function (newVal) {
      this.erpSettingsObject = Object.assign({}, newVal)
    }
  }
}

</script>